import { getTimeZoneStandard } from "utils/timezone";

export const getPM10 = (data, fieldsPM10) => {
  let list = {
    version: "v1",
    info: {
      label: "pm10",
      id: "pm10",
    },
    data: {
      id: "pm10",
      label: "pm10",
      color: [248, 177, 149],
      fields: fieldsPM10,
      rows: [["MIN", null, null, null, null, null, 0],
      ["MAX", null, null, null, null, null, 1]],
    },
  };

  if (data) {
    data?.map((item) => {
      return (
        item?.data !== null &&
        list?.data?.rows?.push([
          item?.station,
          item?.coords.lat,
          item?.coords.long,
          item?.cluster,
          item?.address,
          item?.data,
          item?.data_norm,
        ])
      );
    });
  }
  return list;
};
export const getPM2_5 = (data, fields) => {
  let list = {
    version: "v1",
    info: {
      label: "pm2_5",
      id: "pm2_5",
    },
    data: {
      id: "pm2_5",
      label: "pm2_5",
      color: [248, 177, 149],
      fields: fields,
      rows: [["MIN", null, null, null, null, null, 0], ["MAX", null, null, null, null, null, 1]],
    },
  };

  if (data) {
    data?.map((item) => {
      return (
        item?.data !== null &&
        list?.data?.rows?.push([
          item?.station,
          item?.coords.lat,
          item?.coords.long,
          item?.cluster,
          item?.address,
          item?.data,
          item?.data_norm,
        ])
      );
    });
  }
  return list;
};

export const getPM2_5Heatmap = (data, fields) => {
  let list = {
    version: "v1",
    info: {
      label: "pm2_5",
      id: "pm2_5",
    },
    data: {
      id: "pm2_5",
      label: "PM2.5",
      color: [248, 177, 149],
      rows: [
        ["MIN", null, null, null, null, null, 0],
        ["MAX", null, null, null, null, null, 1],
      ],
      fields: fields,
    },
  };

  if (data) {
    data?.map((item) => {
      return (
        item?.data !== null &&
        list?.data?.rows?.push([
          item?.station,
          item?.coords.lat,
          item?.coords.long,
          item?.cluster,
          item?.address,
          item?.data,
          item?.data_norm,
          getTimeZoneStandard(item?.time),
        ])
      );
    });
  }
  return list;
};
export const getPM10Heatmap = (data, fields) => {
  let list = {
    version: "v1",
    info: {
      label: "pm10",
      id: "pm10",
    },
    data: {
      id: "pm10",
      label: "pm10",
      color: [248, 177, 149],
      rows: [
        ["MIN", null, null, null, null, null, 0],
        ["MAX", null, null, null, null, null, 1],
      ],
      fields: fields,
    },
  };
  if (data) {
    data?.map((item) => {
      return (
        item?.data !== null &&
        list?.data?.rows?.push([
          item?.station,
          item?.coords.lat,
          item?.coords.long,
          item?.cluster,
          item?.address,
          item?.data,
          item?.data_norm,
          getTimeZoneStandard(item?.time),
        ])
      );
    });
  }
  return list;
};